export function addNumberDelimiterForPrice(number) {
  if (number !== 0 && !number) return '';

  let priceStr = '';
  if (typeof number === 'string') {
    priceStr = number;
  } else if (typeof number === 'number') {
    priceStr = number.toString(10);
  } else {
    return '';
  }

  return priceStr.replace(/(\d)(?=(\d\d\d)+$)/g, '$1,');
}
